import { IEnvironment } from './environment.model';

export const environment: IEnvironment = {
  MSPOS_IS_DEPLOYED_BUILD: false,
  MSPOS_APP_VERSION: '3.26.4-dev0',
  MSPOS_API_VERSION: 3,
  MSPOS_MANAGER_API_VERSION: 1,
  MSPOS_ENVIRONMENT: 'dev',
  MSPOS_SERVER_STATUS_URL:
    'https://status.mealsuite.com/api/v2/incidents/unresolved.json',
  API_URL: undefined,
  showLanguageSwitcher: true,
  walkme: {
    ios: { key: '3c011e21-853d-44ab-bc56-9a93b2709838', secret: 'aWdOc3VycGtSN3h3UnVycG5pNFZkY3YrM1VmbUx1Qnd2cUgwcjkxYlRTQi9mSWhZbkVhSUpOMWNwSEVtdnlKcXo3' },
    android: {
      key: 'cd3586fd-7e16-49f4-abfa-13a11192b840',
      secret: 'd3NFbWpsaDR0cWppNnlzdXJwOFpYZnZGZWFFTzBCb2JtVXBNNXNLV2t1a3hXdGdremhraUtHMGFTeVZ0TmU5NGZN'
    },
    webToken: '0fdf2c07a1444cd0a7ca00293ce2b0c5'
  }
};
